import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import { DeleteIcon, EyeIcon, ToDoIcon } from '@/shared/components/Icons';
import FormattedDateTime from '@/shared/components/FormattedDateTime';
import classNames from 'classnames';
import RelationName from '@/shared/components/RelationName';
import FormattedListValue from '@/shared/components/FormattedListValue';
import DocumentService from '@/shared/services/DocumentService';
import FileIcon from '@/shared/components/FileIcon';

import { injectStateService, StateService } from '@/shared/services/StateService';
import messages from './notificationMessages';

const NotificationRow = ({
  notification,
  stateService,
  intl,
  markRead,
  markExpired,
  openTaskDialog,
}) => (
  <tbody className="hover">
    <tr className={classNames({ 'unseen-notification-row': notification.unread })}>
      <td>
        <FormattedDateTime value={notification.createDate} />
      </td>
      <td>{notification.relation && <RelationName relation={notification.relation} />}</td>
      <td>
        {notification.type === 0 ? (
          <span>{notification.params.Text}</span>
        ) : (
          <FormattedListValue
            list="notificationType"
            id={notification.type}
            values={notification.params}
          />
        )}
        {(notification.type === 800 || notification.type === 801) &&
        notification.params &&
        notification.params.document &&
        notification.params.document.id ? (
          <span className="inline-email-attachment margin10L">
            <span>
              <a
                onClick={() => DocumentService.download(notification.params.document.id)}
                title={intl.formatMessage(messages.DownloadFile)}
              >
                <FileIcon document={notification.params.document} />
                {notification.params.document.name}
              </a>
            </span>
          </span>
        ) : null}

        {(notification.type === 501 || notification.type === 502) &&
          notification.params &&
          notification.params.info &&
          notification.params.info.taskId && (
            <span className="inline-email-attachment margin10L">
              <a onClick={() => openTaskDialog(notification.params.info.taskId)}>
                <ToDoIcon className="margin5R" />
                <span>{notification.params.info.name}</span>
              </a>
            </span>
          )}
        {notification.type === 501 &&
          notification.params &&
          notification.params.info &&
          !!notification.params.info.assignedBy && (
            <span className="margin5L">
              <FormattedMessage {...messages.AssignedBy} />
              :&nbsp;
              {notification.params.info.assignedBy}
            </span>
          )}
        {notification.type === 502 &&
          notification.params &&
          notification.params.info &&
          !!notification.params.info.completedBy && (
            <span className="margin5L">
              <FormattedMessage {...messages.CompletedBy} />
              :&nbsp;
              {notification.params.info.completedBy}
            </span>
          )}
        {notification.type >= 1000 && notification.type <= 1005 ? (
          <>
            <span>:</span>
            <span className="margin5L">
              {notification.params?.shareMessage ? (
                <i
                  className="fa fa-comment-o fa-fw margin5R"
                  title={notification.params?.shareMessage}
                />
              ) : null}

              {notification.params?.shareUrl ? (
                <a href={notification.params?.shareUrl} target="_blank">
                  {notification.params?.shareSubject}
                </a>
              ) : (
                <span>{notification.params?.shareSubject}</span>
              )}
            </span>
          </>
        ) : null}
      </td>
      <td className="text-right">
        {notification.unread && (
          <EyeIcon tooltip={intl.formatMessage(messages.MarkAsRead)} onClick={markRead} />
        )}
        {!notification.unread && !notification.expireDate && (
          <DeleteIcon tooltip={intl.formatMessage(messages.Delete)} onClick={markExpired} />
        )}
      </td>
    </tr>
  </tbody>
);

NotificationRow.propTypes = {
  notification: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  stateService: PropTypes.instanceOf(StateService).isRequired,
  intl: intlShape.isRequired,
  markRead: PropTypes.func.isRequired,
  markExpired: PropTypes.func.isRequired,
  openTaskDialog: PropTypes.func.isRequired,
};

export default injectIntl(injectStateService(NotificationRow));
